import { createBrowserRouter } from "react-router-dom";
import PrivateRoute from "../../src/Router/PrivateRoute/PrivateRoute";
import Main from "../Layout/Main";
import Blog from '../Pages/Blog/Blog';
import Home from "../Pages/Home/Home";
import Services from "../Pages/Home/Services";
import Login from "../Pages/Login/Login";
import Myreviews from "../Pages/MyReviews/Myreviews";
import NotFound from '../Pages/NotFound/NotFound';
import ServiceDetail from "../Pages/ServiceDetail/ServiceDetail";
import ServiceReview from "../Pages/ServiceDetail/ServiceReview";
import ServicesInputForm from "../Pages/ServiceForm/ServicesInputForm";
import Signup from '../Pages/SignUp/Signup';

const router = createBrowserRouter([
  {
    path:'/',
    element:<Main></Main>,
    children:[
      {
        path: "/",
        element: <Home></Home>,
        loader:()=>fetch('https://spooky-journalist-server.vercel.app/limitedService')
      },
      {
        path:'/login',
        element:<Login></Login>
      },
      {
        path:'/signup',
        element:<Signup></Signup>
      },
      {
        path:'/blog',
        element:<Blog></Blog>
      },
      {
        path:'/services',
        element:<Services></Services>,
        loader:()=>fetch('https://spooky-journalist-server.vercel.app/services')
      },
      {
        path:'/services/:id',
        element:<ServiceDetail></ServiceDetail>,
        loader:({params})=>fetch(`https://spooky-journalist-server.vercel.app/services/${params.id}`)
      },
      {
        path:'/services-form',
        element:<ServicesInputForm></ServicesInputForm>
      },
      {
        path:'/services/:id',
        element:<PrivateRoute><ServiceReview></ServiceReview></PrivateRoute>,
        loader:({params})=>fetch(`https://spooky-journalist-server.vercel.app/reviews/${params.id}`)
      },
      {
        path:'/myreviews/:id',
        element:<Myreviews></Myreviews>,
        loader:({params})=>fetch(`https://spooky-journalist-server.vercel.app/myreviews/${params.id}`)
      },
      {
        path:'*',
        element:<NotFound></NotFound>
      }
    ]

  }
]);
export default router;